import type SymbolStyleTypeUtil from "./SymbolStyleTypeUtil";

const es = global.es; // TODO: Remove dependency!

export default class ClusterStyleTypeUtil {
    private symbolStyleTypeUtil: SymbolStyleTypeUtil;

    constructor(symbolStyleTypeUtil: SymbolStyleTypeUtil) {
        this.symbolStyleTypeUtil = symbolStyleTypeUtil;
    }

    /**
     * 
     * @param style 
     * @param geom 
     * @param point 
     * @param resolution 
     * 
     * @returns 
     */
    containsPoint(style, geom, point, resolution: number): boolean {
        let ret = false;
        const bounds = [-0.5, -0.5, 0.5, 0.5];
        const size = style.radius * resolution;
        for (let b = bounds.length; b-- > 0; ) {
            bounds[b] *= size;
        }
        
        const testBounds = [0,0,0,0];
        es.api.geom.extractPoints(geom, function(array, index){ //test for each point in geom.
            if(!ret){ // only bothe with this if it is not already inside the bounds of a symbol
                testBounds[0] = bounds[0] + array[index];
                testBounds[1] = bounds[1] + array[index+1];
                testBounds[2] = bounds[2] + array[index];
                testBounds[3] = bounds[3] + array[index+1];

                ret = es.util.bounds.containsPoint(testBounds, point);
            }
        });

        return ret;
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getColor(style): number {
        let color = -1;
        let max = -1;
        const color2Count = style.color2Count;
        for (let c in color2Count) {
            const test = color2Count[c];

            if (test > max) {
                color = c;
                max = test;
            }
        }

        return color;
    }
    
    /**
     * 
     * @param style 
     * @param color 
     * 
     * @returns 
     */
    withColor(style, color) {
        style = es.util.object.deepCopy(style);
        delete style._hash;
        
        style.numFeatures = 1;
        style.color2Count = {};
        style.color2Count[color] = 1;

        return style;   
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    mainColor(style) {
        return this.getColor(style);
    }

    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getPaddingPx(style) {
        var n = style.radius*2;
        return [n,n];
    }
    
    /**
     * 
     * @param style 
     * @param geom 
     * @param pnt 
     * 
     * @returns 
     */
    getFocalPoint(style, geom, pnt): any[] {
        return this.symbolStyleTypeUtil.getFocalPoint(style, geom, pnt);
    }
    
    /**
     * 
     * @param style 
     * 
     * @returns 
     */
    getText(style) {
        return style.text;
    }

    getFocalBounds(style, geom): any[] {
        return this.symbolStyleTypeUtil.getFocalBounds(style, geom);
    }
    
    hasDirect(style): boolean {
        return false;
    }
    
    hasOverlays(style): boolean {
        return true;
    }
}
